import React from 'react';
import Layout from '@/components/Layout';
import Home from '@/pages/home';
import SelfClosure from '@/pages/selfClosure';
import Download from '@/pages/download/download';
import SelfUnlock from '@/pages/selfUnlock';
import ChangeBindApp from '@/pages/changeBindApp';
import Pay from '@/pages/pay';
import KfIndex from '@/pages/kf/home';
import KfTrackIndex from '@/pages/kf/kfTrackIndex';
import KfTrackDetailIndex from '@/pages/kf/kfTrackDetail';
import RecoveredItems from '@/pages/kf/recoveredItems';
import QiBaoItemsRecovered from '@/pages/kf/qiBaoItemsRecovered';
import UnsealApplication from '@/pages/kf/unsealApplication';
import Page404 from '@/pages/404'

const routes = [
  {
    path: '/',
    element: <Layout/>,
    children: [
      {
        path: '/',
        element: <Home/>,
      },
      {
        path: '/original_phone',
        element: <ChangeBindApp/>,
      },
      {
        path: '/wegame_pay',
        element: <Pay/>,
      },
      {
        path: '/closure_info',
        element: <SelfClosure/>,
      },
      {
        path: '/unlock_info',
        element: <SelfUnlock/>,
      },
      {
        path: '/kf',
        element: <KfIndex/>,
      },
      {
        path: '/kf/index.html',
        element: <KfIndex/>,
      },
      {
        path: '/kf/kfTrackIndex',
        element: <KfTrackIndex/>,
      },
      {
        path: '/kf/kfTrackIndex',
        element: <KfTrackIndex/>,
      },
      {
        path: '/kf/kfTrackDetail',
        element: <KfTrackDetailIndex/>,
      },
      {
        path: 'kf/kfItemsRecovered',
        element: <RecoveredItems/>,
      },
      {
        path: '/kf/QiBaoItemsRecovered',
        element: <QiBaoItemsRecovered/>,
      },
      {
        path: '/kf/kfItemsResume',
        element: <UnsealApplication/>,
      },
    ],
  },
  {
    path: '/download/download.html',
    element: <Download/>,
  },
  { path: '/*', element: <Page404/> }
];

export default routes;